import RedactionPanelContainerWithProvider from './RedactionPanelContainer';

export default RedactionPanelContainerWithProvider;